document.addEventListener('DOMContentLoaded', () => {
  const addToCartButtons = document.querySelectorAll('form[action^="/cart/add"] button[type="submit"]');

  if (!addToCartButtons.length) return;

  addToCartButtons.forEach((btn) => {
    const label = btn.querySelector('.btn-label');

    if (label) {
      // Verificación inicial del texto al cargar
      const initialText = label.textContent.trim().toUpperCase();
      if (initialText === 'PREVENTA') {
        label.textContent = 'Comprar En Preventa';
      }

      // Observa cambios en el texto del botón
      const observer = new MutationObserver(() => {
        const newText = label.textContent.trim().toUpperCase();
        if (newText === 'PREVENTA') {
          label.textContent = 'Comprar En Preventa';
        }
      });

      observer.observe(label, { childList: true, subtree: true, characterData: true });
    }

    // Mostrar el modal si el botón es preventa
    btn.addEventListener('click', function () {
      const texto = this.textContent.trim().toUpperCase();
      if (texto === 'PREVENTA' || texto === 'COMPRAR EN PREVENTA') {
        showPresaleModal();
      }
    });
  });

  // Mostrar el modal de preventa
  function showPresaleModal() {
    const overlay = document.getElementById('presale-modal-overlay');
    if (overlay) {
      overlay.style.display = 'flex';
      document.documentElement.classList.add('remove-scrolling');
    }
  }

  // Cerrar el modal
  document.querySelectorAll('[data-close-modal]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const id = btn.getAttribute('data-close-modal');
      const overlay = document.getElementById(id);
      if (overlay) {
        overlay.style.display = 'none';
        document.documentElement.classList.remove('remove-scrolling');
      }
    });
  });

  // Confirmar preventa solo cierra el modal
  const confirmBtn = document.querySelector('[data-confirm]');
  if (confirmBtn) {
    confirmBtn.addEventListener('click', () => {
      const overlay = document.getElementById('presale-modal-overlay');
      if (overlay) {
        overlay.style.display = 'none';
        document.documentElement.classList.remove('remove-scrolling');
      }
    });
  }
});
